export interface ProgressInitType {
    progress: number;
}

export const initialState: ProgressInitType = {
    progress: 0,
};
